import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  bodyContainer : {
    width: '100vw',
    padding: '0',
    margin: '0',
    maxWidth: '100%'
  }
}))